import styled from '@emotion/styled';

type FloatingActionButtonDivProps = React.HTMLAttributes<HTMLDivElement>;

const FloatingActionButtonDiv = styled.div<FloatingActionButtonDivProps>({
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'absolute',
  top: -30,
  right: 0,
  zIndex: 99
});

export default FloatingActionButtonDiv;
